import { render, staticRenderFns } from "./TabbedCard.vue?vue&type=template&id=71e47f44&scoped=true&"
import script from "./TabbedCard.vue?vue&type=script&lang=ts&"
export * from "./TabbedCard.vue?vue&type=script&lang=ts&"
import style0 from "./TabbedCard.vue?vue&type=style&index=0&id=71e47f44&scoped=true&lang=css&"
import style1 from "./TabbedCard.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e47f44",
  null
  
)

export default component.exports